module.exports = __webpack_public_path__ + "static/media/not-published-icon.c54a7175.svg";